import MethodBuilder from "../method-builder";
import { TPaymentProvider } from "../types";

export class PaymentAPI {
  static getProviders = new MethodBuilder<void, TPaymentProvider[]>()
    .withName("Payment.getProviders")
    .build();
}
